<template>
  <v-expansion-panels flat accordion multiple :value="[state]" v-model="expanded">
    <v-expansion-panel v-for="(item , i) in services" :key="i">
      <v-expansion-panel-header
        class="text-uppercase px-0"
        @click="expandHandler(item)"
      >
        <div class="d-flex align-center">
          <v-img v-if="item.icon" eager :src="item.icon" alt="tcdc-service" class="shrink mr-3" contain width="40px" height="40px"></v-img>
          <span class="text-tcdc-green header bold">{{ item[`title_${lang}`] }}</span>
        </div>
        <template v-slot:actions>
          <v-icon v-if="expanded.some(index => i === index)" class="text-tcdc-green" size="medium">mdi-minus</v-icon>
          <v-icon v-else class="text-tcdc-green" size="medium">mdi-plus</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <Membership v-if="item.slug_url.includes('membership')" />
        <!-- <TcdcMember v-if="item.layout == 2" /> -->
        <ResourceCenter v-if="item.slug_url.includes('resource-center')" />
        <VentureHire v-if="branchId != 0 && item.slug_url.includes('venue-hire')" />
        <VisitLayout v-if="branchId != 0 && item.slug_url.includes('service-area')" />
        <div v-if="branchId == 0 && item.slug_url.includes('venue-hire')">
          <div
              v-for="(branch, i) in siteMenuVenueHire" :key="i"
              class="bold text-tcdc-green mb-2 cursor-pointer"
              style="font-size: 20px;"
              @click="goToBranchMenu(branch.tag_name, item.slug_url)"
          >
            {{ branch['branch_name_'+lang] }}
          </div>
        </div>
        <div v-if="branchId == 0 && item.slug_url.includes('service-area')">
          <div
              v-for="(branch, i) in allBranches.filter(x => x.tag_name !== 'all' && x.tag_name !== 'mini-tcdc')" :key="i"
              class="bold text-tcdc-green mb-2 cursor-pointer"
              style="font-size: 20px;"
              @click="goToBranchMenu(branch.tag_name, item.slug_url)"
          >
            {{ branch['branch_name_'+lang] }}
          </div>
        </div>
      </v-expansion-panel-content>
      <Divider />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Divider from "../../components/dividers/Divider";
const Membership = () => import("../../components/member_layouts/Membership");
// import TcdcMember from "../../components/member_layouts/TcdcMember";
// import Layout3 from "../../components/member_layouts/Layout3";
const VentureHire = () => import("../../components/venture_hire/VentureHire");
// import Layout5 from "../../components/member_layouts/Layout5";
const VisitLayout = () => import("../../components/visit_service_area/Visit");
const ResourceCenter = () => import("../../screens/resource_center/ResourceCenter");
import { mapState } from 'vuex';
import { Utils } from "@/util/Utils";

export default {
  props: {
    expandable: {
      type: Boolean,
      default: false
    },
    state: {
      default: null
    }
  },
  data: () => ({
    expanded: [],
    title_name : '',
  }),
  computed:{
    ...mapState({
      services: state => state.ServiceMenu.service_menu,
      siteMenuVenueHire: state => {
        if (state.Branch.siteMenu && state.Branch.siteMenu.length > 0) {
          for (const x of state.Branch.siteMenu) {
            if (x.title_en === 'SPACE RENTALS') {
              return x.branches
            }
          }
        }
        return []
      },
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang : state=> state.Branch.lang
    }),
  },
  created() {
    if (this.state) {
      this.expanded.push(this.state);
    }
  },
  components: {
    Divider,
    Membership,
    // TcdcMember, // it's a wuswug
    // Layout3,
    VentureHire,
    // Layout5,
    VisitLayout,
    ResourceCenter
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    expandHandler(item) {
      if(item){
        let slug_url = item.slug_url;
        // let branch;
        // slug_url = slug_url.slice(slug_url.lastIndexOf('/') + 1);
        // console.log(`/service/${slug_url}`);
        // for (const b of this.allBranches) {
        //   if (this.branchId === b.branch_id) {
            // if (this.branchId === 0) {
            //   branch = ``;
            //   break;
            // }
        //     branch = `/${b.tag_name}`;
        //     break;
        //   }
        // }

        // 16/08/21 only all branches can listing branch for both menus
        if (this.branchId == 0 && (slug_url.includes('visit-and-service-area') || slug_url.includes('venue-hire'))) {
          return
        }

        if(this.$route.path.includes('home')) {
          const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
          this.$router.push(`/${this.lang}`+`${branch}/service${slug_url}`)
        } else {
          this.$router.push(`${this.$route.path}${slug_url}`)
        }
        // if(slug_url === 'resource-center') {
        //   this.$router.push({path: `/service/${slug_url}`, params: {}})
        // } else {
        //   this.$router.push(`/service/${slug_url + branch}`)
        // }
      }
    },
    goToBranchMenu (branchTag, slug) {
      let menuLink = `/${this.lang}/${branchTag}/service/${slug}`
      this.$router.push(menuLink)
    }
  }
};
</script>

<style></style>
